var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M24.273 14.273h3.272a.818.818 0 1 1 0 1.636h-.818v10.636A2.455 2.455 0 0 1 24.273 29H16.09a2.455 2.455 0 0 1-2.455-2.455V15.91h-.818a.818.818 0 0 1 0-1.636h3.273v-.818A2.455 2.455 0 0 1 18.545 11h3.273a2.455 2.455 0 0 1 2.455 2.455v.818zm-1.637 0v-.818a.818.818 0 0 0-.818-.819h-3.273a.818.818 0 0 0-.818.819v.818h4.91zm2.455 1.636h-9.818v10.636c0 .452.366.819.818.819h8.182a.818.818 0 0 0 .818-.819V15.91z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#F44B48",
    fillRule: "nonzero",
    transform: "translate(-12 -11)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.62110c35ae4cd9ed9a7435671bc72c22.svg";
export { ForwardRef as ReactComponent };